module.exports = __webpack_public_path__ + "img/consultant.4e909964.png";